import USER_PERMISSIONS from './userPermissions'
import OrgSettingsPage from '../../pages/OrgSettings/OrgSettingsPage/OrgSettingsPage'
import CalendarPageProvider from '../../pages/Calendar/CalendarPageProvider/CalendarPageProvider'
import ProfileSettingsPage from '../../pages/ProfileSettings/ProfileSettingsPage/ProfileSettingsPage'
import SignUpPage from '../../pages/SignUp/SignUpPage'
import ForgotPasswordPage from '../../pages/ForgotPassword/ForgotPasswordPage/ForgotPasswordPage'
import ResetPasswordPage from '../../pages/ResetPassword/ResetPasswordPage/ResetPasswordPage'
import CourtsPage from '../../pages/Courts/CourtsPage/CourtsPage'
import { USER_ADDONS } from './userAddons'
import SendConfirmationEmailPage from '../../pages/SendConfirmationEmail/SendConfirmationEmailPage'
import ConfirmEmailPage from '../../pages/ConfirmEmail/ConfirmEmailPage'
import SubscriptionPage from '../../pages/Subscription/SubscriptionPage/SubscriptionPage'
import InvitationsList from '../../pages/InvitationsList/InvitationsList'
import InvitationLanding from '../../pages/InvitationLanding/InvitationLanding'
import OrgUsersPage from '../../pages/OrgUsers/OrgUsersPage/OrgUsersPage'
import AppsPage from '../../pages/Apps/AppsPage/AppsPage'
import LivestreamPlayerPage from '../../pages/LivestreamPlayerPage/LivestreamPlayerPage'
import TeamStatisticsPage from '../../pages/Statistics/TeamStatisticsPage'
import PlayerStatisticsPage from '../../pages/Statistics/PlayerStatisticsPage'
import GameStatisticsPage from '../../pages/Statistics/GameStatisticsPage'
import CmsAdminPage from '../../pages/CmsAdminPage/CmsAdminPage'
import PairedCmsPage from '../../pages/PairedCmsPage/PairedCmsPage'
import BrandingPage from '../../pages/BrandingPage/BrandingPage'
import DefaultOverlaysListPage from '../../pages/DefaultOverlaysPage/DefaultOverlaysListPage'
import DefaultOverlayEditorPage from '../../pages/DefaultOverlaysPage/DefaultOverlayEditorPage'
import TeamsPage from '../../components/TeamsPage/TeamsPage'
import PlayersPage from '../../pages/PlayersPage/PlayersPage'
import TeamSettingsPage from '../../pages/TeamSettings/TeamSettingsPage/TeamSettingsPage'
import ClubsPage from '../../pages/ClubsPage/ClubsPage'
import ClubPage from '../../pages/ClubPage/ClubPage'
import DistributionPage from '../../pages/Distribution/DistributionPage/DistributionPage'
import StudioPage from '../../pages/Studio/StudioPage/StudioPage'
import StudioGamePage from '../../pages/Studio/StudioGamePage/StudioGamePage'

const { ALL, STATS, FANS, ENGAGE } = USER_ADDONS

const ROUTES = [
  {
    exact: true,
    path: '/signUp',
    component: SignUpPage,
    noLayout: true,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
  },
  {
    exact: true,
    path: '/forgot-password',
    component: ForgotPasswordPage,
    noLayout: true,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
  },
  {
    exact: true,
    path: '/reset-password',
    component: ResetPasswordPage,
    noLayout: true,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
  },
  {
    exact: true,
    path: '/send-confirmation-email',
    component: SendConfirmationEmailPage,
    noLayout: true,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
  },
  {
    exact: true,
    path: '/confirm-email',
    component: ConfirmEmailPage,
    noLayout: true,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
  },
  {
    exact: true,
    path: '/invitations/:orgId/:invitationId',
    component: InvitationLanding,
    noLayout: true,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
  },
  {
    exact: true,
    path: '/profile',
    component: ProfileSettingsPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
  },
  {
    exact: false,
    path: '/calendar',
    component: CalendarPageProvider,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: false,
    path: '/teamCalendar',
    component: CalendarPageProvider,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/orgSettings',
    component: OrgSettingsPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    requiredPermission: USER_PERMISSIONS.UPDATE_ORG,
    payLocked: false,
  },
  {
    exact: true,
    path: '/teamSettings',
    component: TeamSettingsPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/courts',
    component: CourtsPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/orgUsers',
    component: OrgUsersPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    requiredPermission: USER_PERMISSIONS.GET_ORG_USERS,
    payLocked: false,
  },
  {
    exact: true,
    path: '/apps',
    component: AppsPage,
    noLayout: false,
    allowedOrgAddons: ALL,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    requiredPermission: USER_PERMISSIONS.LINK_YOUTUBE_ACCOUNT,
    payLocked: true,
  },
  {
    exact: true,
    path: '/invitationsList',
    component: InvitationsList,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: false,
  },
  {
    exact: true,
    path: '/subscription',
    component: SubscriptionPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    requiredPermission: USER_PERMISSIONS.DO_BILLING,
    payLocked: false,
  },
  {
    exact: true,
    path: '/livestream/:id',
    component: LivestreamPlayerPage,
    noLayout: true,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
  },
  {
    exact: true,
    path: '/stats',
    component: TeamStatisticsPage,
    noLayout: false,
    allowedAddons: [STATS],
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/stats/player/:playerId',
    component: PlayerStatisticsPage,
    noLayout: false,
    allowedAddons: [STATS],
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/game/stats',
    component: GameStatisticsPage,
    noLayout: false,
    allowedAddons: [STATS],
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/cms',
    component: CmsAdminPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/paired-cms',
    component: PairedCmsPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/distribution',
    component: DistributionPage,
    noLayout: false,
    allowedAddons: [FANS, ENGAGE],
    allowedUserOrgRoles: ALL,
    requiredPermission: USER_PERMISSIONS.UPDATE_CHANNEL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/clubs',
    component: ClubsPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    requiredPermission: USER_PERMISSIONS.READ_TEAM,
    payLocked: true,
  },
  {
    exact: true,
    path: '/clubs/:clubId',
    component: ClubPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    requiredPermission: USER_PERMISSIONS.READ_TEAM,
    payLocked: true,
  },
  {
    exact: true,
    path: '/branding',
    component: BrandingPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    // Dev-only editor for the bundled default overlays. The backend's
    // /v1/admin/default-overlays endpoints return 404 outside Development,
    // so navigating here on a deployed environment will just show an error.
    exact: true,
    path: '/default-overlays',
    component: DefaultOverlaysListPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: false,
  },
  {
    // Editor for a single bundled default overlay. Variant (e.g. Roster 10..15)
    // is carried in ?variant=N so refreshing or sharing the URL keeps the picker
    // selection. Same dev-only gate as the list above — backend 404s elsewhere.
    exact: true,
    path: '/default-overlays/:slug',
    component: DefaultOverlayEditorPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: false,
  },
  {
    exact: true,
    path: '/teams',
    component: TeamsPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/teams/:teamId',
    component: TeamStatisticsPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/seasonTeams/:teamId',
    component: TeamStatisticsPage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/players',
    component: PlayersPage,
    noLayout: false,
    allowedAddons: [STATS],
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/competition/stats/player/:playerId',
    component: PlayerStatisticsPage,
    noLayout: false,
    allowedAddons: [STATS],
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/studio',
    component: StudioPage,
    noLayout: false,
    // Studio is a Pro tier feature, not an add-on. Anyone in the org may reach the page; the API
    // returns only the games they are actually assigned to.
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
  {
    exact: true,
    path: '/studio/games/:gameId',
    component: StudioGamePage,
    noLayout: false,
    allowedAddons: ALL,
    allowedUserOrgRoles: ALL,
    payLocked: true,
  },
]

export default ROUTES
